import shot1 from '../../media/shots/shot-1.jpg';
import shot2 from '../../media/shots/shot-2.jpg';
import shot3 from '../../media/shots/shot-3.jpg';
import shot4 from '../../media/shots/shot-4.jpg';
import shot5 from '../../media/shots/shot-5.jpg';
import shot6 from '../../media/shots/shot-6.jpg';

export const HERO_FACTS = [
  'Solo or 1–4 co-op',
  'Windows via Steam',
  'Keyboard or controller',
];

export const FEATURES = [
  {
    title: 'No second chance',
    body: "If it goes out, you don't get another. Carry wood, keep it fed, get back before the smoke is gone.",
  },
  {
    title: 'Last the night',
    body: 'Sleep when you can. You wake up colder, with more wolves in the trees.',
  },
  {
    title: 'Bring people',
    body: 'Solo or up to four on Steam. Split the wood runs. Drag anyone who freezes back to the heat.',
  },
];

export const SCREENSHOTS = [
  { src: shot1, alt: 'A survivor sits beside a roaring campfire as snow falls around the tent.' },
  { src: shot2, alt: 'A distant camp fire burning under a pale moon in open snow country.' },
  { src: shot3, alt: 'A wolf crossing a moonlit ridge above the treeline.' },
  { src: shot4, alt: 'A whiteout blizzard reducing the forest to silhouettes.' },
  { src: shot5, alt: 'A lone fire on a far hillside seen across the snowfields at night.' },
  { src: shot6, alt: 'Firelight throwing long shadows across the snow beside a tent.' },
];

// The FAQ copy lives in faq-content.mjs so the build step can turn it into
// FAQPage structured data without importing the images above.
